// src/App.js
import React, { useMemo } from 'react';
import { store } from './redux/store';
import { Provider } from 'react-redux';
import { ToastContainer } from 'react-toastify';
import Navigation from './components/Navigation';
import { BrowserRouter } from 'react-router-dom';

const App = () => {
  const toastOptions = useMemo(() => ({
    position: "top-right",
    autoClose: 4000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "light",
  }), []);

  return (
    <Provider store={store}>
      <BrowserRouter>
        <ToastContainer {...toastOptions} />

        <div >
          <Navigation />
        </div>
      </BrowserRouter>
    </Provider>
  );
}

export default App;
